import { createRouter, createWebHistory } from "vue-router";
export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", component: () => import("./views/OverviewView.vue"), meta: { title: "Обзор" } },
    { path: "/store", component: () => import("./views/StoreView.vue"), meta: { title: "Магазин" } },
    { path: "/syncs", component: () => import("./views/SyncsView.vue"), meta: { title: "Синхронизации" } },
    { path: "/search", component: () => import("./views/SearchIndexView.vue"), meta: { title: "Поисковый индекс" } },
    { path: "/usage", component: () => import("./views/UsageView.vue"), meta: { title: "Расходы AI" } },
    { path: "/events", component: () => import("./views/EventsView.vue"), meta: { title: "События и ошибки" } },
    { path: "/audit", component: () => import("./views/AuditView.vue"), meta: { title: "Аудит" } },
  ],
});
